import React, { useRef, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import ShopCard from './ShopCard';

// Import Swiper styles
import 'swiper/css';
import './ShopCarousel.css'; // Nos styles personnalisés

const ShopCarousel = ({ shops, onSlideChange, onCardClick, onInfoClick, initialShopId }) => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Mettre à jour l'index actif lorsque la slide change
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
    if (shops[swiper.realIndex]) {
      onSlideChange(shops[swiper.realIndex].id);
    }
  };

  // Permet de faire glisser le carrousel vers une boutique spécifique
  useEffect(() => {
    if (initialShopId && swiperRef.current && shops.length > 0) {
      const index = shops.findIndex(shop => shop.id === initialShopId);
      if (index !== -1 && swiperRef.current.swiper) {
        swiperRef.current.swiper.slideTo(index);
        // Mettre à jour l'index actif immédiatement
        setActiveIndex(index);
        // Appeler onSlideChange pour synchroniser la carte dès le début
        // onSlideChange(initialShopId); // Commenté pour éviter double appel initial
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialShopId, shops]); // Dépend de initialShopId et shops


  if (!shops || shops.length === 0) {
    return null; // Ne rien afficher si pas de boutiques
  }

  return (
    <div className="shop-carousel-container">
      <Swiper
        ref={swiperRef}
        slidesPerView={'auto'} 
        slidesOffsetAfter={60}
        grabCursor={true}
        onSlideChange={handleSlideChange} 
        initialSlide={shops.findIndex(shop => shop.id === initialShopId) || 0} 
        className="shop-carousel"
      >
        {shops.map((shop, index) => (
          <SwiperSlide key={shop.id}>
            <ShopCard 
              shop={shop} 
              isActive={index === activeIndex} // Marque la carte active
              onClick={onCardClick} // Gère le clic sur une carte
              onInfoClick={onInfoClick} // Gère le clic sur le bouton info
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ShopCarousel; 